export const PaymentStatus = { SUCCESS: 0, FAILURE: 1, CANCEL: 2 };
